import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';

import ParadigmaModal from "../../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../../api";

import ParadigmaAsyncSeeker from "../../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"


class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            Nombre: "",
            Padre_id: null,
            postVariables: ["Padre_id", 'Nombre'],
            errors: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE']).isRequired,
    }

    resetForm() {
        this.setState({
            id: null,
            Nombre: "",
            Padre_id: null,
            errors: [],
        });
    }

    getData() {
        const { postVariables } = this.state;
        let data = {};
        postVariables.forEach(x => {
            data[x] = this.state[x];
        });
        return data;
    }

    setData(data) {
        if (data.success) {
            this.setState({
                id: data.id,
                Nombre: data.Nombre,
                Padre_id: data.Padre_id ? data.Padre_id : null,
            })
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    modalVars() {
        const { action } = this.props;
        if (action == "CREATE") {
            return {
                get: false,
                submitType: "POST",
                title: "Nueva Categoria",
                buttonTitle: "Nuevo",
                danger: false,
                buttonIcon: "fa fa-plus fa-lg",
                successMessage: "La Categoria ha sido creado con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
            };
        } else if (action == "EDIT") {
            return {
                get: true,
                submitType: "PUT",
                title: "Editar Categoria",
                buttonTitle: "Editar",
                danger: false,
                buttonIcon: "fa fa-pencil fa-lg",
                successMessage: "La Categoria ha sido editado con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
                id: this.props.id,
            };
        } else if (action == "DETAIL") {
            return {
                get: true,
                submitType: null,
                title: "Categoria",
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",
                disabled: true,
                id: this.props.id,
            };
        } else if (action == "DELETE") {
            return {
                get: true,
                submitType: "DELETE",
                title: "Eliminar Categoria",
                buttonTitle: "Eliminar",
                danger: true,
                buttonIcon: "fa fa-trash fa-lg",
                successMessage: "La Categoria ha sido eliminado con éxito.",
                saveButton: true,
                saveButtonLabel: "Eliminar",
                buttonClass: "btn-danger",
                disabled: true,
                id: this.props.id,
            };
        }
    }

    render() {
        let vars = this.modalVars();
        const { action } = this.props;
        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.gestion.articulos.categorias : null)}
                submitUrl={(vars.submitType ? api.gestion.articulos.categorias : null)}
                submitType={vars.submitType}
                id={vars.id}

                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e) & this.resetForm()}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}

                title={vars.title}

                danger={vars.danger}
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                saveReloadButton={action == "CREATE"}
                saveReloadButtonLabel="Guardar y Nuevo"
                closeButton={true}
            >
            <ParadigmaLabeledInput
               md={[2, 10]}
               label={"Padre"}
               inputComponent={
                   <ParadigmaAsyncSeeker
                       disabled={vars.disabled}
                       url={api.gestion.articulos.categorias}
                       value={this.state.Padre_id}
                       displayField="Nombre"
                       parameters={{paginationEnabled:"False"}}
                       onChange={(data) => this.onChangeField('Padre_id', (data ? data.id : null))}
                   />
               }
               error={() => this.getError('padre_id')}
            />
                <ParadigmaLabeledInput
                    disabled={vars.disabled}
                    md={[2, 10]}
                    label={"Nombre"}
                    value={this.state.Nombre}
                    onChange={(e) => this.onChangeField('Nombre', e.target.value)}
                    error={() => this.getError('Nombre')}
                />

            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Gestion/Articulos/Categorias/Modal.js